import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash.get';

import { onDonationTypeChange, paymentClear } from '../reducer';

import { donationTypeOptions } from '../../../constants/donationTypeOptions';

class DonateTypeSelectView extends React.Component {
    handleChange = value => {
        this.props.onDonationTypeChange(value);
    }

    render() {
        return (
            <React.Fragment>
                {
                    !this.props.disableDonationRecurringGiving &&
                    <div className="donation-type-pager">
                        {
                            React.Children.toArray(
                                donationTypeOptions.map(option => {
                                    const isActive = option.value === this.props.value;
                                    return (
                                        <div
                                            className={`donation-type-option ${isActive ? "active" : ""}`}
                                            onClick={this.handleChange.bind(this, option.value)}
                                            style={{ flexGrow: 1 }}
                                        >
                                            {option.label}
                                        </div>
                                    );
                                })
                            )
                        }
                    </div>
                }

            </React.Fragment>
        );
    }
}

const mapState = state => {
    return {
        value: get(state.donation, 'subscription.enabled'),
        disableDonationRecurringGiving: get(state.page.campaign, 'template.value.donationSetup.disableRecurringGiving'),
    };
};

const mapDispatch = dispatch => {
    return {
        onDonationTypeChange(isRecurring) {
            dispatch(onDonationTypeChange(isRecurring));
        },
        paymentClear() {
            dispatch(paymentClear());
        }
    };
};

const DonateTypeSelect = connect(mapState, mapDispatch)(DonateTypeSelectView);
export default DonateTypeSelect;